import type { ReactNode } from 'react';

interface Props {
  message: ReactNode | null;
}

export default function PaymentError({ message }: Props) {
  if (!message) return null;
  return (
    <div role="alert" className="rounded-xl border border-red-100 bg-red-50/80 p-4">
      <p className="text-sm text-red-700">{message}</p>
    </div>
  );
}
